module.exports = __webpack_public_path__ + "img/Unykach.8375ccef.jpg";